import { generatePath } from 'react-router';

import { Navigate, useTypedParams } from '@sorare/routing';
import { FOOTBALL_MARKET_SCOUT_LEADERBOARDGROUP } from '@sorare/core/src/constants/__generated__/routes';

import type { PageParams } from './__generated__/routeParams.ts';

const RedirectToScoutingCenterStatsLeaderboardGroupPage = () => {
  const { leaderboardGroup } = useTypedParams<PageParams>();
  return (
    <Navigate
      to={generatePath(FOOTBALL_MARKET_SCOUT_LEADERBOARDGROUP, {
        leaderboardGroup,
      })}
    />
  );
};

export default RedirectToScoutingCenterStatsLeaderboardGroupPage;
